import { useState, MouseEvent, SetStateAction, Dispatch } from 'react'
import { ToggleButtonGroup, ToggleButton } from '@mui/material'

type InventoryButtonsProps = {
  statusFilter: string,
  setStatusFilter: Dispatch<SetStateAction<string>>,
}

const InventoryButtons = (props: InventoryButtonsProps) => {
  const { statusFilter, setStatusFilter } = props

  const handleToggle = (event: MouseEvent<HTMLElement>, value: string) => {
    setStatusFilter(value)
  }

  return (
    <ToggleButtonGroup
      size="small"
      color="primary"
      value={statusFilter}
      exclusive
      onChange={handleToggle}
    >
      <ToggleButton value="active">
        Active
      </ToggleButton>
      <ToggleButton value="inactive">
        Inactive
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default InventoryButtons
